import type { Board } from '../entities/Board';
import type { GridPosition, PieceData } from '../types/game.types';

export interface ValidMoves {
  moveTiles: GridPosition[];
  attackTiles: GridPosition[];
}

const DIRECTIONS: GridPosition[] = [
  { row: -1, col: 0 }, // up
  { row: 1, col: 0 },  // down
  { row: 0, col: -1 }, // left
  { row: 0, col: 1 },  // right
];

export class MoveSystem {
  calculateValidMoves(board: Board, position: GridPosition): ValidMoves {
    const piece = board.getPiece(position);
    if (!piece) return { moveTiles: [], attackTiles: [] };

    const moveTiles: GridPosition[] = [];
    const attackTiles: GridPosition[] = [];

    for (const dir of DIRECTIONS) {
      const target: GridPosition = {
        row: position.row + dir.row,
        col: position.col + dir.col,
      };

      if (!board.isInBounds(target)) continue;

      const targetPiece: PieceData | null = board.getPiece(target);

      if (targetPiece === null) {
        moveTiles.push(target);
      } else if (targetPiece.side !== piece.side) {
        attackTiles.push(target);
      }
      // same-side piece: blocked — do nothing
    }

    return { moveTiles, attackTiles };
  }

  getAllValidMoves(board: Board, position: GridPosition): GridPosition[] {
    const { moveTiles, attackTiles } = this.calculateValidMoves(board, position);
    return [...moveTiles, ...attackTiles];
  }
}
